// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2326":"2f462bed917b6d34","7026":"63143a3aa4953f20","7888":"62673d9a00ca1f27","8117":"719955f0329b91f9"}[chunkId] + ".js";
};